var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    strokeDasharray: "164.93361431346415 56.97787143782138",
    r: 35,
    strokeWidth: 10,
    stroke: "#3572d8",
    fill: "none",
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animateTransform", {
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    dur: "3.4482758620689653s",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderBlue);
export default __webpack_public_path__ + "static/media/loader-blue.2ed16bfcbe90ca70aabb5684919fb461.svg";
export { ForwardRef as ReactComponent };